module.exports = __webpack_public_path__ + "static/media/26_A.95f23a1a.png";